<template>
<div style="width:100%" >
    <div :class="'g_desktopOn '+headerList">
        <div> 
        <s-button 
                @onclick="openModalFilter=true" 
                :icon="isFilterActive ? 'check-circle' : 'filter'"
                :theme="isFilterActive ? 'is-success' : 'is-primary'" 
                label="Filtrer"
                />&nbsp;
        <s-button 
            label="Opérations" 
            @onclick="openModalInscrireAll=true" 
            theme='is-primary' 
            icon="bolt"
            v-show="tournoi && tournoi.options.mode=='ALEA' && tournoi.state=='INSCRIPTION'"
            :role="role"
            />&nbsp;
            <s-input-search v-model="joueurSearch.pseudo" 
                themeEraser="is-warning" theme="is-primary" placeholder="Recherche par pseudo" 
                maxlength="10" width="250px"/>
                &nbsp;
            <s-button icon="user-plus" @onclick="addJoueur" theme="is-success is-normal" 
            label="Ajouter un membre" :role="role"
            v-if="!tournoi"
            :tuto="tuto"
             />&nbsp;
             <s-button theme="is-primary is-normal" icon="plus" 
             label="Ajouter un joueur" @onclick="addJoueur" v-if="tournoi"
             
             />
        </div>
        <div>
            <div class="HeaderItem">
            <b>Filtres : {{nbJoueurByFilter}} / {{joueurs.length}} joueurs </b>
            </div>
             <div class="HeaderItem" v-if="tournoi && tournoi.preinscription" >
            <b>Préinscriptions : 
                <span v-if="tournoi.joueurs.length < tournoi.preinscription.length">{{tournoi.preinscription.length - tournoi.joueurs.length}} </span>
                <span v-else>0</span>
            </b></div>
            <div class="HeaderItem" v-if="tournoi && tournoi.joueurs">
                <b>Inscriptions : {{tournoi.joueurs.length}}</b>
            </div>
        </div>

    </div>
       
    <div class="g_menuMobile" v-show="!openModal && !hideMenuMobile">
        <table class="g_menuFooterMin">
            <tr>
                <td colspan="5" class="g_headerFooter" >
                    {{titleMobile}} 
                    <div style="float:right;padding-right: 30px;font-size:12px" v-if="optionDisplay.inscription">
                        {{tournoi.joueurs.length}} inscrits
                        <b v-if="tournoi.preinscription">
                            <span v-if="tournoi.joueurs.length < tournoi.preinscription.length"> / {{tournoi.preinscription.length - tournoi.joueurs.length}} </span>
                            <span v-else> / 0</span>préinscrits
                        </b>
                    </div>
                </td>
            </tr>
            <tr>
                 <td v-show="!mobileSearch  && optionDisplay.inscription && optionDisplay.forme">
                    <s-button icon="list" @onclick="$emit('setNav','equipe')" theme="is-primary" label="Liste des équipes"
                     mode="V"/>
                </td>
                <td v-show="!mobileSearch && !optionDisplay.forme">
                    <s-button  icon="undo" @onclick="back()" theme="is-warning" label="Retour" mode="V" />
                </td>
                <td  >
                   <s-button  v-show="!mobileSearch" icon="search" @onclick="mobileSearch=true" theme="is-light" label="Rechercher" mode="V"/>
                   <s-button v-show="mobileSearch" icon="undo" @onclick="mobileSearch=false" theme="is-warning" label="Retour" mode="V"/>
                </td>
                <td v-show="mobileSearch" >
                         <s-button icon="filter" @onclick="openModalFilter=true" 
                          theme="is-light" label="Filtrer" mode="V"/>
                </td>
                <td colspan="2" v-show="mobileSearch" style="vertical-align:top;padding-right:20px;" >
                    <s-input maxlength="10" theme="is-normal" 
                            v-model="joueurSearch.pseudo" width="200px" 
                            placeholder="Recherche par pseudo" 
                            
                    />
                </td>
                 <td v-show="!mobileSearch">
                        <s-button icon="user-plus" 
                            @onclick="addJoueur"  theme="is-light" label="Ajouter" mode="V"
                            id="Ajouter un membre"/>
                </td>
                 <td v-show="!mobileSearch && optionDisplay.membre">
                    <s-button icon="cog" @onclick="$emit('config')" theme="is-light" label="Configurer" mode="V"/>
                </td>
                 <td v-show="!mobileSearch  && optionDisplay.membre">
                    <s-button icon="file-excel" @onclick="openModalDownload=true" theme="is-light" label="Télécharger" mode="V"/>
                    
                </td>
                
                 <td v-show="!mobileSearch  && optionDisplay.inscription && optionDisplay.forme">
                    <s-button icon="plus" @onclick="$emit('createTeam')" theme="is-primary" label="Former une équipe"
                     mode="V"/>
                </td>
                 <td v-show="!mobileSearch  && optionDisplay.inscription && !optionDisplay.forme">
                    <s-button icon="bolt" @onclick="openModalInscrireAll=true" theme="is-light" label="Opérations" mode="V"/>
                </td>
                 <td v-if="tournoi" v-show="!mobileSearch  && optionDisplay.inscription && !optionDisplay.forme && !tournoi.clotured">
                    <s-button icon="play" @onclick="$emit('start')" theme="is-success" label="Démarrer" mode="V"/>
                </td>
                 <td  v-if="tournoi" v-show="!mobileSearch  && optionDisplay.inscription && !optionDisplay.forme && tournoi.clotured">
                    <s-button label="Classement" 
                        :role="role"  
                        @onclick="$emit('editClassement')" 
                        theme="is-warning" 
                        icon="edit"
                        v-show="tournoi.clotured"
                        mode="V"
                    />
                </td>
                 
                <td v-show="!mobileSearch  && optionDisplay.inscription && optionDisplay.forme">
                    <s-button icon="recycle" @onclick="$emit('generate')" theme="is-success" label="Générer" mode="V"/>
                </td>
            </tr>
        </table>
        <s-modal
            title="Ajouter des joueurs"
            :open="addModalJoueurInscription"
            @close="addModalJoueurInscription=false"
            :close="true"
        >
            <s-button label="Ajouter un membre au club" icon="user-plus"                
                    theme="is-primary " @onclick="addModalJoueur=true;addModalJoueurInscription=false" :role="role" />
            <br/><br/>
            <s-button label="Ajouter des invités" icon="handshake"                
                    theme="is-warning " 
                    @onclick="modalAnonyme=true;addModalJoueurInscription=false" :role="role" />
        </s-modal>
        <s-modal
            title="Importer ou Exporter sous excel"
            :open="openModalDownload"
            @close="openModalDownload=false"
            :close="true"
        >
            Importer ou Exporter sous excel<br/><br/>
            <s-button label="Importer vos membres" icon="download"                
                    theme="is-primary " @onclick="$emit('import')" :role="role" /><br/><br/>
            <s-button label="Exporter vos membres" icon="upload"                
                    theme="is-primary " @onclick="$emit('export')" :role="role" />
        </s-modal>
    </div>
    <s-modal 
        title="Opérations de masse"
        :open="openModalInscrireAll"
        @close="openModalInscrireAll=false"
        :close="true"
        @cancel="openModalInscrireAll=false"
        :cancel="true"
        
    >
        <div style="width:100%">
            <div class="buttonMasse">
            <s-button 
                label="Préinscire" 
                theme="is-warning" 
                icon="signature"
                @onclick="enMasse(0)"
                />&nbsp;
                <div style="text-align:center;width: 100%"> S'applique aux membres filtrés <br/>(si vous avez choisi un filtre)</div>
            </div>
            <div class="buttonMasse">
            <s-button 
                label="Inscrire tous les préinscrits" 
                theme="is-success" 
                icon="check-double"
                @onclick="enMasse(1)"
               />&nbsp;
            </div>
            <div class="buttonMasse">
            <s-button 
                label="Retirer alétoirement les numéros" 
                theme="is-info" 
                icon="bolt" 
                @onclick="aleatoireInscription()"
               />&nbsp;
            </div>
        </div>
        <div>
             <div class="buttonMasse">
            <s-button 
                label="Désinscrire" 
                theme="is-danger" 
                icon="user-minus"
               
                @onclick="enMasse(2)" />&nbsp;
            </div>
             <div class="buttonMasse">
            <s-button 
                label="Tout désinscrire" 
                theme="is-black" 
                icon="eraser"
                @onclick="enMasse(3)" />&nbsp;
            <div style="text-align:center;width: 100%"> Vous revenez à l'origine</div>
            </div>
        </div>
        <div style="width: 100%;text-align:center">
            <div class="buttonMasse">
                <s-button label="Ajouter plusieurs invités" 
                    theme="is-info" 
                    icon="plus"
                    @onclick="modalAnonyme=true"
                />
            </div>
            <div class="buttonMasse">
                <s-button 
                    label="Supprimer les invités" 
                    theme="is-primary" 
                    icon="trash"
                    @onclick="openModalInscrireAll=false;openModaldeleteAllInvite=true" />
            </div>
        </div>
    </s-modal>
    
    <filter-modal
        :open="openModalFilter"
        :filters="filters"
        :inscritOnOff="tournoi ? true : false"
        @close="openModalFilter=false"
        @apply="applyfilter"    
        @cancel="cancelFilter"
    />
    
    <add-modal-invites
        :open="modalAnonyme"
        @addAnonymes="AddJoueursAnonymes"
        @close="modalAnonyme=false"
    />
    

    
    <div class="team" v-if="forme && !alea">
        <div class="teamHeader">
            <div class="numero">
                {{getNumeroJoueurTournoi()+1}}
            </div>
            <div style="display:inline-block" v-if="meneur">
                <s-input theme="input is-small is-rounded is-light" width="150px"
                 placeholder="Nom de l'équipe" :mandatory="false"  v-model="nameEquipe" @blur="saveNameEquipe()"/>
                 <s-button theme="is-info is-small" @onclick="saveNameEquipe()" icon="save" label=""
                   
                 />
            </div>
            <div style="display:inline-block" v-if="!meneur">
                Sélectionnez votre capitaine
            </div>
        </div>
        <div>
        <div class="teamMeneur" v-if="meneur">
             
              <div style="margin:3px" class="g_mobileOn">
                    <s-button theme="is-danger is-small" :role="role" icon="trash" label="" @onclick="$emit('deleteEquipe', meneur)"/>
             </div>
            <div class="teamMeneurItem">
                <div  style="float:left;margin-right:3px">
                <s-button theme="is-info is-small" :role="role" icon="user-edit" label="" @onclick="editJoueurForme(meneur, false)"/>
                 </div>
                <b>{{meneur.pseudo}}</b>
                <span v-if="meneur.nom=='' && meneur.pseudo==''"><b>Invité</b></span>
                <br/>
                <div class="nomprenom">{{meneur.nom }} {{meneur.prenom}}
                    
                </div>
                    
                
            </div>
            <div  v-if="meneur.coequipier1" class="teamMeneurItem">
            <div  style="float:left;margin-right:3px">
                 <s-button theme="is-info is-small" :role="role" icon="user-edit" label="" @onclick="editJoueurForme(meneur.coequipier1, true)"/>
            </div>
            <div style="float:right">
                 
                <s-button theme="is-danger is-small" :role="role" icon="user-minus" label="" @onclick="supCoequipier(1)"/>
            </div>
            {{getJoueurById(meneur.coequipier1).pseudo}} &nbsp;&nbsp;
            <span v-if="getJoueurById(meneur.coequipier1).pseudo==''">Invité</span>
             <div class="nomprenom">{{getJoueurById(meneur.coequipier1).nom}} {{getJoueurById(meneur.coequipier1).prenom}}</div>
            
            </div>
            <div v-if="meneur.coequipier2" class="teamMeneurItem">
              <div  style="float:left;margin-right:3px">
                 <s-button theme="is-info is-small" :role="role" icon="user-edit" label="" @onclick="editJoueurForme(meneur.coequipier2, true)"/>
            </div>
            <div style="float:right">
                <s-button theme="is-danger is-small" :role="role" icon="user-minus" label="" @onclick="supCoequipier(2)"/>
            </div>
            {{getJoueurById(meneur.coequipier2).pseudo}} &nbsp;&nbsp;
            <span v-if="getJoueurById(meneur.coequipier2).pseudo==''">Invité</span>
            <div class="nomprenom">{{getJoueurById(meneur.coequipier2).nom}} {{getJoueurById(meneur.coequipier2).prenom}}</div>
            
            </div>
        </div>
        </div>
        <div style="position:absolute; bottom: 0px;text-align:center;width:100%;margin:1px" class="g_desktopOn" v-if="meneur">
                    <s-button theme="is-danger is-small" :role="role" icon="trash" label="Supprimer l'équipe" @onclick="supEquipe=true"/>
                    <s-confirm  
                        :open="supEquipe"
                        @yes="$emit('deleteEquipe', meneur);supEquipe=false"
                        @no="supEquipe=false"
                    >
                        Etes vous sûr de vouloir supprimer cette équipe ?
                    </s-confirm>
        </div>
    </div>
    
        
    <edit-invit
        :open="modalInvite"
        @refresh="refresh"
        @close="modalInvite=false"
        :joueur="joueur"
        :joueurs="joueurs"
        :tournoi="tournoi"
        :club="club"
        @inviteToMembre="inviteToMembre"
        @OpenModalInvites="OpenModalInvites"
         @saved="changeJoueur"
    />

    <edit-vue
        :open="addModalJoueur"
        :joueur     = "joueur"
        :joueurs    = "joueurs"
        :clubData   = "club"
        :tournoi    = "tournoi"   
        :owner = "owner"
        @close="addModalJoueur=false"
        ref="editJoueur"
        @saved="changeJoueur"
    />
    <s-confirm
        :open="openModaldeleteAllInvite"
        @yes="deleteAllInvite"
        @no="openModaldeleteAllInvite=false"
    >
        <s-l id='deleteAllInvite'>Vous êtes sur le point de supprimer tous les invités<br/>Confirmez vous la suppression ?</s-l>
    </s-confirm>
    <input type="hidden" :value="joueurs"/>
    <div v-if="joueurs.length==0 && tournoi" class="g_notItems">
        <s-l  id="joueurs_notMembreInscrits">Il n'y a aucun membre pour ce club pour le moment <br/>Vous pouvez en ajouter directement ici ou revenez à votre club et cliquez sur membre pour les créer.<br/><br/>Vous pouvez aussi ajouter des joueurs anonymes !</s-l>
    </div>
    <div v-if="joueurs.length==0 && !tournoi" class="g_notItems">
        <s-l  id="joueurs_notMembre">Il n'y a aucun membre pour ce club pour le moment <br/>Vous pouvez en créer un par un en cliquant sur "Ajouter un membre"<br/>Ou importer des membres en masse par le biais d'un fichier excel.</s-l>
    </div>
    
    <div :class="displayList ? 'listJoueurs' : 'listJoueursForme'">
        <div  
            v-for="(joueurItem, indexJoueur) in joueurs" 
            style="display:inline-block">
            <list-item 
                :joueur="joueurItem" 
                :tournoi="tournoi"
                :meneur="meneur"
                :role="role"
                :forme="forme"
                :refresh="refreshJoueur"
                :joueurSearch="joueurSearch"
                :filters="filters"
                :filterInscrit="filterInscrit"
                :filterByLicencie="filterByLicencie"
                :equipes="equipes"
                :owner="owner"
                :alea="alea"
                :selection="selection"
                @joinTeam="setTeamJoined"
                @joinTournoi="joinTournoi"
                @preinscription="preinscription"
                @editJoueur="editJoueur"
                @desinscrire="desinscrire"
                @desincrireAnonyme="desincrireAnonyme"
                @selectEquipe="selectEquipe"
            />
            
            
        </div>
    </div>
    <waiting :open="modalStarting"/>
</div>
  
</template>
<style scoped>
    .HeaderItem {
        display: inline-block;
        font-size: 12px;
        margin-left: 20px;
    }
    .slabel  {
        font-size: 16px;
        color : black;
        font-weight: bolder;
        width: 200px;
    }
    .smenuList {
        margin-top:5px;
        margin-left:0px;
        text-align:left;
        height:70px;
        position: fixed;
        top: 100px;
        padding-left: 10px;
        z-index: 3;
    }
    .smenuModalList {
        
    }
    .listJoueurs {
       
        
    }
     
    @media screen and (max-width: 420px) {
        .listJoueurs {
            text-align: center;
            margin-bottom: 100px;   
            margin-top: 100px;
        }
        .buttonMasse {
            display:inline-block;
            width:100%;
            vertical-align:top;
            height: 90px;
            padding: 15px;
            text-align:center;
            font-size: 14px;
            font-weight: bolder;
            color: black;
        }
        .teamHeader {
            position: fixed;

        }
         .team {
            padding: 5px;
            border: thin rgb(87, 83, 54) solid;
            background-color:rgb(240, 239, 236);
            margin-left: auto;
            margin-right: auto;
            border-radius: 10px;
            height: 100px;
            width: 100%;
            vertical-align: top;
            position: fixed;
            top: 60px;
            z-index: 3;
            
             overflow: auto;
        }
        .listJoueursForme {
            margin-top: 170px;
            margin-bottom: 100px;
            width: 100%;
            height: 100%;
            margin-left: auto;
            margin-right: auto;
            text-align: center;
        }
        .teamMeneur {
            vertical-align: top;
            height: 60px;
            display: inline-flex;
            margin-top: 30px;
            
        }
         .teamMeneurItem {
            padding: 10px;
            border: thin solid silver;
            border-radius: 10px;
            margin-left: 5px;
            margin-top: 5px;
            height: 50px;
            width: 230px;
            font-size: 12px;
            display: inline-block;
        }
    }
    @media screen and (min-width: 420px) {
        .listJoueurs {
            margin-left: auto;
            margin-right: auto;
            height: 80%;
            width: 100%;
            margin-top: 200px;
        }
        .buttonMasse {
            display:inline-block;
            width:50%;
            vertical-align:top;
            height: 100px;
            padding: 20px;
            text-align:center;
            font-weight: bolder;
            color: black;
        }
         .team {
            padding: 5px;
            border: thin rgb(87, 83, 54) solid;
            background-color:rgb(240, 239, 236);
            margin: 10px;
            border-radius: 10px;
            height: 300px;
            display:inline-block;
            width: 250px;
            vertical-align: top;
            position: fixed;
            top: 200px;
        }
        .teamMeneur {
            vertical-align: top;
            height: 90px;
        }
         .teamMeneurItem {
            padding: 10px;
            border: thin solid silver;
            border-radius: 10px;
            margin-left: 5px;
            margin-top: 5px;
            height: 70px;
            width: 230px;
            font-size: 12px;
        }
        .listJoueursForme {
            margin-top: 00px;
            margin-left: 270px;
            display: inline-block;
            margin-bottom: 0px;
            width: 80%;
            height: 100%;
        }
    }
   
    .numero {
        background-color: greenyellow;
        border-radius: 20px;
        
        width: 40px;
        text-align: center;
        display: inline-block;
        margin-right: 10px;
        color: rgb(6, 43, 2);
        font-size: 20px;
    }
    .buttonFilter {
        height: 50px;
        display: flex;
        margin: 10px;
        width: 250px;
    }
    
    .buttonSave {
         display: inline-block;
    }
   
    .participe {
        margin-top: 4px;
        margin-right: 10px;
        font-weight: bold;
        font-size: 20px;
        height: 10px;
        display: inline-block;
    }
    
    .partieItem {
        display: inline;
        padding-right: 10px;
    }
   
    .buttonsJoueurs {
        padding-top: 5px;
    }
    .itemSelected {
        background-color: rgb(164, 243, 164);
        padding: 2px;
        height: 50px;
        margin-bottom: 10px;
    }
    .nomprenom {
        font-style: italic;
        font-size: 12px;
    }
</style>
<script>

/*
<s-button theme="is-normal" 
            :label="getNumeroJoueurTournoi(joueurItem)!=-1 ? (parseInt(getNumeroJoueurTournoi(joueurItem)) + 1) + ' : ' + joueurItem.pseudo : joueurItem.pseudo" 
            icon="edit" @onclick="editJoueur(joueurItem)"  :role="role"
        />
        */
const { v4: uuidv4 } = require('uuid');
import firebase_api from "@/firebase/firebase_api"
import firebase from "firebase"
import club_fct     from '@/firebase/club'
import user         from '@/firebase/user'
import tournoi_fct  from '@/firebase/tournoi'

import joueur_fct   from '@/firebase/joueur'

import Tirage       from '@/firebase/tirage2/tirage'
import Equipe_object from '@/firebase/tirage2/Equipe'
import editVue      from '@/views/joueurs/edit.vue'
import listItem     from '@/views/joueurs/listItem.vue'

import filterModal     from '@/views/joueurs/filterModal.vue'
import addModalInvites  from '@/views/joueurs/addModalInvites.vue'
import EditInvit  from '@/views/joueurs/editInvite.vue'

export default {
    props: ["club", "selection","tournoi", 'indexPartie','role','meneur','equipes','changeMembre', 'alea','saison','options','titleMobile', 'hideMobile'],
    components: {
        editVue,
        listItem,
        filterModal,
        addModalInvites,
        EditInvit
    },
    
    data() {
        return {
            openJoueurModify: false,
            joueur : JSON.parse(JSON.stringify(joueur_fct.object.data)),
            joueurSearch: JSON.parse(JSON.stringify(joueur_fct.object.data)),
            addModalJoueur: false,
            supEquipe:false,
            error: null,
            handler: null,
            filters: {},
            operator: {},
            filterInscrit: null,
            filterByLicencie: null,
            openModalFilter: false,
            openModalInscrireAll: false,
            modalInvite: false,
            joueursFilters: [],
            refreshJoueur: false,
            modalStarting: false,
            searchPseudo: "",
            modalAnonyme: false,
            filtempo: null,
            mobileSearch: false,
            openModalDownload: false,
            addModalJoueurInscription: false,
            openModaldeleteAllInvite: false,
            joueurs: [],
            nbJoueurByFilter: 0
            
        }
    },
   
    computed: {
        /*joueursFilters: {
            get() {
                var joueurFilters=[];
                this.joueurs.forEach(joueurItem=>{
                    if(this.search(joueurItem))
                        joueurFilters.push(joueurItem)
                })
                return joueurFilters;
            }
        },*/
        nameEquipe: {
            get() {
                
                if (typeof(this.meneur.nameEquipe)=="undefined")
                    return "";
                else
                    return this.meneur.nameEquipe;
            },
            set(name) {
               
                this.meneur.nameEquipe = name;
            }
        },
        tuto: {
            get() {
                var bool = false
                
                if (this.club.demo)
                    bool = this.club.tuto==1
               
                return bool;
            }
        },
        headerList: {
            get() {
                if (typeof(this.tournoi)=="undefined")
                    return "smenuList"
                else if (this.tournoi.state == 'INPROGRESS') 
                    return 'smenuModalList'
                else
                    return "smenuList"
                }
        }
        ,
        hideMenuMobile: {
            get() {
                if (typeof(this.hideMobile) == "undefined") 
                    return false;
                else
                    return this.hideMobile;
            }
        },
        displayList: {
            get() {
               if (typeof(this.tournoi) == "undefined")
                    return true;
                else if (this.alea)
                        return true;
                    else
                        return this.tournoi.options.mode != 'FORME'
            }
        },
       
        optionDisplay: {
            get() {
                if (typeof(this.options)=="undefined")
                    return  {};
                else
                    return this.options;
            }
        },
        openModal: {
            get() {
                return this.addModalJoueur || this.openModalFilter || this.openModalInscrireAll || this.modalAnonyme;
            } 
        },
        owner: {
            get() {
                var users = this.club.users;
                
                var idOwner = -1;
                for (var key in users) {
                    if (users[key].role == "owner") {
                        idOwner = users[key].id;
                    }
                }
                if (idOwner!=-1) {
                    return idOwner;
                }
                else
                    return null;
            }
        },
        isFilterActive: {
            get() {
                var filter = false;
                for (var filterId in this.filters) {
                    var filterItem = this.filters[filterId];
                    if (!filter)
                    if (filterItem.type=="checkbox") 
                        filter = filterItem.valuesDefault.length != 0;
                    else
                        filter = filterItem.valuesDefault != null;
                }
                if (this.filterByLicencie!=null)
                    filter = filter || this.filterByLicencie;
                return filter;
                return true;
            }
        },
        forme: {
            get() {
                if (this.tournoi) {
                    if (this.tournoi.options.mode == "FORME" &&  this.tournoi.state=='INSCRIPTION' ) 
                            return true;
                        else
                            return false;
                }
                else
                    return false;
            }
        }
    },
   
    created() {
        const component = this;
        this.handler = (e)=> {
            if (typeof(this.tournoi)=="undefined") {
                if (e.which == 13 && !this.addModalJoueur) {
                    this.addJoueur();
                }
                else if (e.which == 13 && this.addModalJoueur) {
                    this.$refs.editJoueur.save();
                }
                    
            }
        }
        window.addEventListener('keyup', this.handler);
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handler);
    },
    methods: {
        saveNameEquipe() {
            var indexJoueur = this.tournoi.joueurs.findIndex(elt=>elt.id === this.meneur.id);
            this.tournoi.joueurs[indexJoueur].nameEquipe = this.meneur.nameEquipe
            tournoi_fct.object.set(this.club, this.tournoi,()=>{
                    
            })
        },
        OpenModalInvites() {
            this.modalInvite = false;
            this.modalAnonyme = true;
        },
        inviteToMembre() {
            this.modalInvite=false;
            this.addModalJoueur=true;
        },
       selectEquipe(equipe) {
           this.$emit("openEquipe", equipe);
       },
       cancelFilter() {
           this.nbJoueurByFilter=this.joueurs.length;
           for (var indexFilter in this.filters) {
               this.filters[indexFilter].valuesDefault = null;
           }
           this.openModalFilter=false;
       },
       getMembersFilters() {
           var members = [];
           
            this.joueurs.forEach(joueur=>{
                if (this.search(joueur)) 
                     members.push(joueur.id)
            })
            return members;
       },
        applyfilter(filters) {
            
            this.filters = filters.filtersCustoms;
            
            this.filterByLicencie = filters.filterByLicencie;
            this.filterInscrit = filters.filterInscrit;
            this.nbJoueurByFilter=0;
            this.openModalFilter=false;
            this.joueurs.forEach(joueur=>{
                if (this.search(joueur)) 
                     this.nbJoueurByFilter++;
            })
            if (typeof(this.selection)!="undefined")
                this.$emit("supSelect")
        },
        
        AddJoueursAnonymes(nbJoueursAnonymes) {
            this.modalAnonyme = false;
            this.$emit("addAnonymes", nbJoueursAnonymes);
        },
         random(min, max) {
            return Math.floor(min + Math.random() * (max - min));
        },
        aleatoireInscription() {
            var listJoueurs=[];
            var listJoueursSup=[];
            
            listJoueursSup = JSON.parse(JSON.stringify(this.tournoi.joueurs.slice()));
            for (var index=0;index<this.tournoi.joueurs.length;index++) {
                listJoueursSup[index] = index;
            }
           
            this.tournoi.joueurs.forEach((joueur, index)=>{
                var indexFind  = this.random(0, listJoueursSup.length);
                var numero = listJoueursSup[indexFind];
                
                listJoueurs[index] = JSON.parse(JSON.stringify(this.tournoi.joueurs[numero]));
                listJoueursSup.splice(indexFind,1);
            })
            this.tournoi.joueurs = JSON.parse(JSON.stringify(listJoueurs));
           
        },
        enMasse(mode) {
           /* 
            Mode = 0 : préinscription des joueurs filtrés
            Mode = 1 : inscription des joueurs préinscrits
            Mode = 2:  désinscription en laissant les préinscrits
            Mode = 3:  RAZ de tout
          */
           this.modalStarting = true;
           if (mode == 3) {
               this.tournoi.preinscription = [];
               this.tournoi.joueurs = [];
           }
           else if (mode == 2) {
               this.tournoi.joueurs.forEach(joueurItem=>{
                    if (typeof(this.tournoi.preinscription)=="undefined") 
                        this.tournoi.preinscription=[];
                    var indexJoueurPresinscrit = this.tournoi.preinscription.indexOf(joueurItem.id);
                    if (indexJoueurPresinscrit==-1) {
                         this.tournoi.preinscription.push(joueurItem.id)
                    }
               })
               this.tournoi.joueurs = [];
           }
           else if (mode == 1) {
               if (typeof(this.tournoi.preinscription)=="undefined")
                        this.tournoi.preinscription= [];
               this.tournoi.preinscription.forEach(idJoueurPreinscrit=>{
                    var indexJoueur = this.joueurs.findIndex(joueur=>joueur.id === idJoueurPreinscrit);
                    var joueurItem = this.joueurs[indexJoueur];
                    var joueurTournoi = JSON.parse(JSON.stringify(joueur_fct.object.tournoi));
                    joueurTournoi.id = joueurItem.id;
                    joueurTournoi.pseudo = joueurItem.pseudo;
                    joueurTournoi.nom = joueurItem.nom;
                    joueurTournoi.prenom = joueurItem.prenom;
                    if (typeof(joueurItem.invite)!="undefined")
                        joueurTournoi.invite = joueurItem.invite;
                    if (typeof(joueurItem.elo)=="undefined")
                        joueurTournoi.elo = 1199;
                    else
                        joueurTournoi.elo = joueurItem.elo;
                    if (!this.isJoin(joueurTournoi)) {
                        this.tournoi.joueurs.push(joueurTournoi);
                    }
               })
               this.aleatoireInscription();
           }
           else if (mode == 0) {
                for (var indexJoueur in this.joueurs) {
                    var joueurItem = this.joueurs[indexJoueur];
                    if (typeof(this.tournoi.preinscription)=="undefined")
                        this.tournoi.preinscription= [];
                    var indexJoueurPresinscrit = this.tournoi.preinscription.indexOf(joueurItem.id);
                    if (indexJoueurPresinscrit == -1 && this.search(joueurItem))
                        this.tournoi.preinscription.push(joueurItem.id);
                }
           }
           tournoi_fct.object.set(this.club, this.tournoi,()=>{
                    
            })
            this.modalStarting = false;
            this.refreshJoueur = !this.refreshJoueur;
            this.openModalInscrireAll = false;
        },
        createEquipe(){
            this.$emit("setMeneur", null);
        },
        supCoequipier(indiceCoequipier) {
            var joueurDesinscriptionId;

            var indexJoueur = this.tournoi.joueurs.findIndex(elt=>elt.id === this.meneur.id);
            if (indiceCoequipier == 1) {
                joueurDesinscriptionId = this.meneur.coequipier1;
                this.meneur.coequipier1 = null;
                this.tournoi.joueurs[indexJoueur].coequipier1 = null;
            }
            else if (indiceCoequipier ==2) {
                joueurDesinscriptionId = this.meneur.coequipier2;
                this.meneur.coequipier2 = null;
                this.tournoi.joueurs[indexJoueur].coequipier2 = null;
            }
            var joueurDesinscriptionData = this.getJoueurById(joueurDesinscriptionId)
         
            this.desinscrire(joueurDesinscriptionData);
        },
        getJoueurById(joueurId) {
            if (typeof(this.tournoi) == "undefined")
                return -1;
            else {
                var indexJoueur = this.tournoi.joueurs.findIndex(elt=>elt.id===joueurId);
                
                return this.tournoi.joueurs[indexJoueur];
            }
        },
        checkState(joueurItem) {
            return !this.isJoin(joueurItem)
        }
            /*
            if (typeof(this.tournoi) == "undefined")
                return !this.isJoin(joueurItem)
            else 
            return (this.tournoi.state=='INSCRIPTION') || (this.tournoi.state=='INPROGRESS' && !this.isJoin(joueurItem))
            */
        ,
       
        closeEdit() {
            this.joueur = JSON.parse(JSON.stringify(joueur_fct.object.data));
            this.error = null;
            this.addModalJoueur = false;
        },
        
        addJoueur() {
            this.joueur = JSON.parse(JSON.stringify(joueur_fct.object.data));
            if (typeof(this.tournoi)=="undefined") {
                this.error = null;
                this.addModalJoueur = true;
            }
            else {
                this.modalInvite = true;
            }
        },
        editJoueur(joueurItem) {
           
            this.joueur = JSON.parse(JSON.stringify(joueurItem));
            
            if (joueurItem.invite) {
                this.modalInvite = true;
            }
            else {
                this.error = null;
                this.addModalJoueur = true;
            }
        },
        editJoueurForme(joueurItem, cooequipier) {
            var index;
            var idJoueur;
            if (cooequipier)
                idJoueur = joueurItem;
            else
                idJoueur = joueurItem.id;
            index = this.joueurs.findIndex(elt=>elt.id === idJoueur);
            if (index!=-1) {
                this.editJoueur(this.joueurs[index])
            }
        },
        search(joueurItem) {
            
            var searchReturn = true;
            
            searchReturn = joueur_fct.object.search(joueurItem, this.filters);
            
            if (this.filterInscrit!=null && searchReturn)
                searchReturn = this.filterInscrit ? this.isJoin(joueurItem) : !this.isJoin(joueurItem);
            
            if (searchReturn) {
                if (this.filterByLicencie != null)
                    searchReturn = this.filterByLicencie == joueurItem.isLicencie;
            }

            if (searchReturn) {
                if (joueurItem.pseudo=="")
                    return true;
                else {
                    if (joueurItem.pseudo.toUpperCase().indexOf(this.joueur.pseudo.toUpperCase()) == 0)
                        return true;
                    else    
                        return false;
                }
            }
            else
                return false;
           
        },
        desincrireAnonyme (joueurItem) {
            var indexJoueur = this.tournoi.joueurs.findIndex(elt=>elt.id === joueurItem.id);
            this.tournoi.joueurs.splice(indexJoueur, 1);
            indexJoueur = this.joueurs.findIndex(elt=>elt.id===joueurItem.id);
            this.joueurs.splice(indexJoueur, 1);
        },
        desinscrire(joueurItem, fct) {
           

            if (typeof(fct) != "undefined")
                tournoi_fct.object.deleteJoueur(this.club, this.tournoi, joueurItem, fct);
            else {
                this.refreshJoueur = !this.refreshJoueur;
                tournoi_fct.object.deleteJoueur(this.club, this.tournoi, joueurItem, ()=>{
                   
                });
            }
        },
         deleteAllInvite() {
            for (var idInvite in this.tournoi.invites) {
                var joueur = JSON.parse(JSON.stringify(this.tournoi.invites[idInvite]));
                delete this.tournoi.invites[idInvite];
                if (typeof(this.tournoi.preinscription)!="undefined") {
                    var index = this.tournoi.preinscription.indexOf(joueur.id);
                    this.tournoi.preinscription.splice(index,1);
                }
                tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                    
                })
                if (this.joueur.email!='')
                    club_fct.object.deleteInvite(joueur, this.club, this.tournoi.id);
            } 
            this.openModalInscrireAll = false;
            
            this.openModaldeleteAllInvite = false;
            this.refresh();
        },
       getNumeroJoueurTournoi() {
            if (typeof(this.equipes)=="undefined") 
                return 0;
            else if (this.meneur==null)
                return this.equipes.length;
            else if (typeof(this.tournoi) == "undefined")
                return "";
            else {
                var indexJoueur = -1
                if (this.forme) {
                    indexJoueur = this.equipes.findIndex(elt=>elt.id === this.meneur.id);
                    if (indexJoueur == -1)
                        indexJoueur = this.equipes.findIndex(elt=>elt.coequipier1 === this.meneur.id);
                    if (indexJoueur == -1)
                        indexJoueur = this.equipes.findIndex(elt=>elt.coequipier2 === this.meneur.id);
                    
                }
                return indexJoueur;
            }
        },
        getJoueurTournoi(joueur) {
            if (typeof(this.tournoi) == "undefined")
                return -1;
            else {
                var indexJoueur = this.tournoi.joueurs.findIndex(elt=>elt.id===joueur.id);
                return this.tournoi.joueurs[indexJoueur];
            }
        },
        isJoin(joueur) {
          
            if (typeof(this.tournoi) != "undefined") {
                if (this.tournoi.joueurs.findIndex(elt=>elt.id===joueur.id) == -1)
                    return false;
                else    
                    return true;
            }
            else
                return false;
        },
        setTeamJoined(joueurParam) {
            
            if (typeof(this.alea) == "undefined" || !this.alea )
                this.joinTeam(joueurParam);
            else {
             
                 this.joinTournoi(joueurParam);
            }
        },
        preinscription(joueurParam) {
            if (typeof(this.tournoi.preinscription) == "undefined") {
                this.tournoi.preinscription = [];
            }
            var list  = this.tournoi.preinscription;
            if (list.indexOf(joueurParam.id) == -1) 
                this.tournoi.preinscription.push(joueurParam.id);
            tournoi_fct.object.set(this.club, this.tournoi, ()=>{

            })
        },
        joinTeam(joueurParam) {
           
            var joueurTournoi = JSON.parse(JSON.stringify(joueur_fct.object.tournoiForme));
            joueurTournoi.id = joueurParam.id;
            joueurTournoi.pseudo = joueurParam.pseudo;
            joueurTournoi.nom = joueurParam.nom;
            joueurTournoi.prenom = joueurParam.prenom;
            if (typeof(joueurParam.invite)!="undefined")
                    joueurTournoi.invite = joueurParam.invite;
            if (typeof(joueurParam.elo) == "undefined")
                joueurTournoi.elo = 1199;
            else
                joueurTournoi.elo = parseFloat(joueurParam.elo);
            if (this.meneur == null) {
                joueurTournoi.meneur = true;
                if (this.tournoi.state != "INPROGRESS") {
                    tournoi_fct.object.addJoueur(this.club, this.tournoi, joueurTournoi, ()=>{
                        this.$emit("setMeneur", joueurTournoi);
                        this.refreshJoueur = !this.refreshJoueur;
                    });
                }
                else {
                    this.$emit("addJoueurInTournoiInProgress", joueurTournoi);
                    this.refreshJoueur = !this.refreshJoueur;
                }
                
            }
            else {
                joueurTournoi.meneur = false;
              
                if (this.meneur.coequipier1==null || this.meneur.coequipier2==null) {
                        tournoi_fct.object.addJoueur(this.club, this.tournoi, joueurTournoi, ()=>{
                        var indexJoueur = this.tournoi.joueurs.findIndex(elt=>elt.id === this.meneur.id);
                        if (this.tournoi.joueurs[indexJoueur].coequipier1 == null) {
                            this.tournoi.joueurs[indexJoueur].coequipier1 = joueurTournoi.id;
                            this.meneur.coequipier1 =  joueurTournoi.id;
                        }
                        else if (this.tournoi.joueurs[indexJoueur].coequipier2 == null) {
                            this.tournoi.joueurs[indexJoueur].coequipier2 = joueurTournoi.id;
                            this.meneur.coequipier2 =  joueurTournoi.id;
                        }
                        tournoi_fct.object.set(this.club, this.tournoi,()=>{});
                            this.refreshJoueur = !this.refreshJoueur;
                     });
                }
                
                
            }    
        },
        joinTournoi(joueurParam, fct) {
          
            if (this.changeMembre!=null) {
                 var joueurTournoi = JSON.parse(JSON.stringify(joueur_fct.object.tournoi));
                joueurTournoi.id = joueurParam.id;
                joueurTournoi.pseudo = joueurParam.pseudo;
                joueurTournoi.nom = joueurParam.nom;
                joueurTournoi.prenom = joueurParam.prenom;
                if (typeof(joueurParam.invite)!="undefined")
                    joueurTournoi.invite = joueurParam.invite;
                  if (typeof(joueurParam.elo) == "undefined")
                    joueurTournoi.elo = 1199;
                else
                     joueurTournoi.elo = parseFloat(joueurParam.elo);

                this.$emit("changeMembre", joueurTournoi);
            }
            else if (this.tournoi.state == "INSCRIPTION" || this.tournoi.state == "INPROGRESS" || this.tournoi.clotured) {
                
                var joueurTournoi = JSON.parse(JSON.stringify(joueur_fct.object.tournoi));
                joueurTournoi.id = joueurParam.id;
                joueurTournoi.pseudo = joueurParam.pseudo;
                joueurTournoi.nom = joueurParam.nom;
                joueurTournoi.prenom = joueurParam.prenom;
                if (typeof(joueurParam.invite)!="undefined")
                    joueurTournoi.invite = joueurParam.invite;
                if (typeof(joueurParam.elo) == "undefined")
                    joueurTournoi.elo = 1199;
                else
                    joueurTournoi.elo = parseFloat(joueurParam.elo);
                
                if (this.tournoi.state == "INPROGRESS") {
                    
                    this.$emit("addJoueurInTournoiInProgress", joueurTournoi);
                  /*
                    AVANT je m'embetais à le mettre dans une équipe existante mais maintenant on s'en fiche
                    on va le mettre dans une équipe vierge mais je laisse au cas où ...
                    TODO : A SUPPRIMER
                    ***********************************************************
                    firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                        .collection("parties").get().then(snapshot=> {
                            var parties = [];
                            snapshot.docs.forEach((partie, indexPartie)=>{
                                var partieData = partie.data();
                               
                                partieData.equipes = [];
                                firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                                .collection("parties").doc("P"+indexPartie.toString()).collection("equipes").get().then(snapShotEquipe=>{
                                    snapShotEquipe.docs.forEach(doc=>{
                                        partieData.equipes.push(doc.data());

                                    })
                                    parties.push(partieData);
                                   
                                    if (indexPartie == snapshot.docs.length - 1) {
                                       
                                        var options = this.tournoi.options;
                                        var tirage_inst = new Tirage(options, parties);
                                        var joueurData =  {
                                            numero : tirage_inst.joueurs.length
                                        }
                                       // var partieEquipe =  tool_tirage.fct.addJoueur(joueurTournoi, parties, this.indexPartie);
                                        var partieEquipe = tirage_inst.addJoueur( joueurData, this.indexPartie);
                                       
                                        for (var setIndexPartie=this.indexPartie;setIndexPartie<partieEquipe.length;setIndexPartie++) {
                                                firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                                            .collection("parties").doc("P"+setIndexPartie.toString())
                                            .collection("equipes").doc("E"+partieEquipe[setIndexPartie].indiceEquipe).set(
                                                    partieEquipe[setIndexPartie].equipe.getJSON()
                                            )
                                        }
                                        // Du coup il faut refaire un check pour les parties qui seraient ou plus en erreur
                                        tirage_inst.parties.forEach((partie,indexPartie)=>{
                                            partie.checkError();
                                            firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                                                .collection("parties").doc("P"+indexPartie.toString()).update({
                                                    error: partie.error
                                                })
                                        })
                                        

                                        
                                        
                                    }
                                })
                                
                            })
                        })
                */
                   

                }
                else if (this.tournoi.state == "INSCRIPTION" || this.tournoi.clotured) {
                    
                    if (typeof(fct) != "undefined")
                        tournoi_fct.object.addJoueur(this.club, this.tournoi, joueurTournoi, fct);
                    else {
                        this.refreshJoueur = !this.refreshJoueur;
                        tournoi_fct.object.addJoueur(this.club, this.tournoi, joueurTournoi, ()=>{
                           
                        });
                    }
                }
            }
        },
        back() {
           
            if (this.options.inscription)
                this.$emit("back");
            else {
                this.$router.push({name: 'viewClub', params: {id: this.club.id}});
            }
        },
        arrayInJson(json_data) {
            var array = [];
            Object.keys(json_data).forEach(key=> {
                array.push(json_data[key])
            })
            return array;
        },
        
        sort() {
            this.joueurs.forEach(joueur=>{
                joueur.pseudoMaj = joueur.pseudo.toUpperCase();
            })
            
            this.joueurs.sort((a,b)=> {
                return a.pseudoMaj.localeCompare(b.pseudoMaj);
            })
           
        },
        refresh() {
            
            this.$bind("joueurs", firebase_api.api.getDb().collection("club").doc(this.club.id)
                .collection("joueurs").orderBy("pseudo")).then(()=>{
                   this.nbJoueurByFilter=this.joueurs.length;
                    this.sort();
                })
            if (typeof(this.tournoi)!="undefined") {
                if (typeof(this.tournoi.invites)!="undefined") {
                    for (var indexInvite in this.tournoi.invites) {
                        this.joueurs.push(this.tournoi.invites[indexInvite]);
                    }
                }
            }
            var filters = JSON.parse(JSON.stringify(this.club.customs));
            for (var indexFilter in filters) {
                        filters[indexFilter].valuesDefault = null;
            }
            this.filters = filters;
           
        },
         changeJoueur(joueurParam) {
            var maj = true;
            if (this.meneur!=null) {
                if (joueurParam.id == this.meneur.id) {
                    this.meneur.nom = joueurParam.nom;
                    this.meneur.prenom = joueurParam.prenom;
                    this.meneur.pseudo = joueurParam.pseudo;
                }
                else {
                 
                    var joueur = this.getJoueurById(joueurParam.id);
                    if (typeof(joueur)!="undefined") {
                        joueur.nom = joueurParam.nom;
                        joueur.prenom = joueurParam.prenom;
                        joueur.pseudo = joueurParam.pseudo;                        
                    }
                    else
                        maj = false;
                }
                if (maj)
                    tournoi_fct.object.set(this.club, this.tournoi, ()=>{

                    })
            }
        },
    },
   
    mounted() {
        this.refresh();
    }
}

</script>